module.exports = __webpack_public_path__ + "static/img/Rectangle 3.3780059e.png";